import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import MobileHeader from '../components/layout/mobileHeader';
import BottomNav from '../components/layout/bottomNav';
import './book.css';

import ticketImg from '../assets/imgs/mobileTicket.png';

const ticketTypes = [
  {
    id: 'One Day Pass',
    name: 'One Day Pass',
    price: 9,
  },
  {
    id: 'VIP',
    name: 'VIP',
    price: 200,
  },
];

const dates = [
  { day: 'Sun', date: '25', fullDate: '2026-01-25' },
  { day: 'Mon', date: '26', fullDate: '2026-01-26' },
  { day: 'Tue', date: '27', fullDate: '2026-01-27' },
  { day: 'Wed', date: '28', fullDate: '2026-01-28' },
  { day: 'Thu', date: '29', fullDate: '2026-01-29' },
];

const Book = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState('2026-01-25');
  const [ticketType, setTicketType] = useState(ticketTypes[0]);
  const [quantity, setQuantity] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState('Credit/Debit Card');
  const [bookingData, setBookingData] = useState(null);
  const [saving, setSaving] = useState(false);

  const totalAmount = ticketType.price * quantity;

  const confirmBooking = async () => {
    setSaving(true);
  
    const payload = {
      date: selectedDate,
      ticket_type: ticketType.name,
      quantity,
      full_name: 'Mobile User',
      email: 'mobileuser@example.com',
      phone: null,
      payment_method: paymentMethod,
      total_amount: totalAmount,
      created_at: new Date().toISOString(),
    };
  
    const { data, error } = await supabase
      .from('bookings')
      .insert([payload])
      .select()
      .single();
  
    setSaving(false);
  
    if (error) {
      alert('Booking failed: ' + error.message);
      console.error('Booking failed:', error.message);
      return;
    }
  
    setBookingData(data);
    setStep(4);
  };

  return (
    <main className="bookPage">
      <MobileHeader />

      {step !== 4 && <h1 className="bookTitle">Book your ticket</h1>}

      {step === 1 && (
        <>
          <ProgressBar activeStep={1} />

          <section className="bookSection">
            <h2>📅 Select Date</h2>

            <div className="dateScroll">
              {dates.map((item) => (
                <button
                  key={item.fullDate}
                  className={selectedDate === item.fullDate ? 'dateCard active' : 'dateCard'}
                  onClick={() => setSelectedDate(item.fullDate)}
                >
                  <span>{item.day}</span>
                  <strong>{item.date}</strong>
                </button>
              ))}
            </div>
          </section>

          <section className="bookSection">
            <h2>🎟 Ticket Type</h2>

            <div className="ticketTypeList">
              {ticketTypes.map((ticket) => (
                <button
                  key={ticket.id}
                  className={ticketType.id === ticket.id ? 'ticketTypeCard active' : 'ticketTypeCard'}
                  onClick={() => setTicketType(ticket)}
                >
                  <div>
                    <h3>{ticket.name}</h3>
                    <p>EGP {ticket.price}.00</p>
                  </div>

                  <span className="radioCircle"></span>

                  <div className="detailsRow">
                    <b>+</b>
                    <p>View details</p>
                  </div>
                </button>
              ))}
            </div>
          </section>

          <section className="bookSection">
            <h2>Quantity</h2>

            <div className="qtyRow">
              <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>-</button>
              <input value={quantity} readOnly />
              <button onClick={() => setQuantity(quantity + 1)}>+</button>
            </div>
          </section>

          <button className="mainBookBtn" onClick={() => setStep(2)}>
            Next
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <ProgressBar activeStep={2} />

          <section className="summarySection">
            <h2>Booking details</h2>

            <SummaryRow label="Date:" value={selectedDate} />
            <SummaryRow label="Ticket Type" value={ticketType.name} />
            <SummaryRow label="Number of Tickets" value={quantity} />
            <SummaryRow label="Price per Ticket" value={ticketType.price} />

            <div className="summaryTotal">
              <strong>Total Amount</strong>
              <strong>{totalAmount}</strong>
            </div>
          </section>

          <button className="mainBookBtn fixedBottomBtn" onClick={() => setStep(3)}>
            Next
          </button>
        </>
      )}

      {step === 3 && (
        <>
          <ProgressBar activeStep={3} />

          <section className="paymentSection">
            <label className="paymentOption">
              <input
                type="radio"
                checked={paymentMethod === 'Credit/Debit Card'}
                onChange={() => setPaymentMethod('Credit/Debit Card')}
              />
              Credit/ Debit Card
            </label>

            <div className="cardRow">
              <span className="mastercard">●●</span>
              <p>**** 2345</p>
              <input type="radio" checked readOnly />
            </div>

            <div className="cardRow">
              <span className="visa">VISA</span>
              <p>**** 3456</p>
              <input type="radio" readOnly />
            </div>

            <button className="addCardBtn">＋ Add Card</button>

            <label className="paymentOption bordered">
              <input
                type="radio"
                checked={paymentMethod === 'Apple Pay'}
                onChange={() => setPaymentMethod('Apple Pay')}
              />
              Apple Pay
              <span>Pay</span>
            </label>

            <label className="paymentOption bordered">
              <input
                type="radio"
                checked={paymentMethod === 'Google Pay'}
                onChange={() => setPaymentMethod('Google Pay')}
              />
              Google Pay
              <span>G Pay</span>
            </label>
          </section>

          <button className="mainBookBtn fixedBottomBtn" onClick={confirmBooking}>
  {saving ? 'Confirming...' : 'Confirm'}
</button>
        </>
      )}

      {step === 4 && (
        <section className="confirmedBox">
          <div className="checkCircle">✓</div>
          <h2>Booking Confirmed</h2>
          <p>Thank you for your payment. We look forward to seeing you soon.</p>

          <button className="mainBookBtn" onClick={() => setStep(5)}>
            View Receipt
          </button>

          <button className="outlineBookBtn" onClick={() => navigate('/Home')}>
            Back to Home
          </button>
        </section>
      )}

      {step === 5 && (
        <section className="receiptPage">
          <h1>Receipt</h1>

          <img src={ticketImg} alt="Ticket receipt" className="receiptTicket" />

          <p className="receiptHint">
            Scan this QR code at the entrance for quick check-in.
          </p>

          <SummaryRow label="Date:" value={bookingData?.date || selectedDate} />
          <SummaryRow label="Ticket Type" value={bookingData?.ticket_type || ticketType.name} />
          <SummaryRow label="Number of Tickets" value={bookingData?.quantity || quantity} />

          <button className="mainBookBtn receiptBtn">
            Download Receipt
          </button>

          <button className="outlineBookBtn" onClick={() => navigate('/Home')}>
            Back to Home
          </button>
        </section>
      )}

      {step !== 4 && <BottomNav activePage="book" />}
    </main>
  );
};

const ProgressBar = ({ activeStep }) => {
  return (
    <div className="bookProgress">
      <span className={activeStep >= 1 ? 'done' : ''}>
        {activeStep > 1 ? '✓' : 'Ticket details'}
      </span>
      <span className={activeStep >= 2 ? 'done' : ''}>
        {activeStep > 2 ? '✓' : 'Summary'}
      </span>
      <span className={activeStep >= 3 ? 'done' : ''}>Payment</span>
    </div>
  );
};

const SummaryRow = ({ label, value }) => {
  return (
    <div className="summaryRow">
      <strong>{label}</strong>
      <span>{value}</span>
    </div>
  );
};

export default Book;